// The panel does the converting. Switch it to Celsius and it recalibrates the
// sensors, then every temperature it sends is already Celsius, with
// temperature_unit riding along to say so (1 = Celsius, 0 = Fahrenheit). So
// nothing here converts anything — it only picks the right letter to print.
//
// When the flag has not arrived yet we return nothing rather than guessing. A
// bare number is honest; a Celsius reading labelled °F is the bug this exists
// to stop.
export const tempUnit = (raw) => {
  if (raw === null || raw === undefined || raw === '') return '';
  return Number(raw) === 1 ? '°C' : '°F';
};

export default tempUnit;
